// Copyright (c) 2025. CYBERKOALA LLC. All Rights Reserved.
// Proprietary license.

import React, { useEffect, useState } from 'react';
import { io as ClientIO } from 'socket.io-client';
import { API_BASE } from '@/config.ts';
import { SocketContext } from '@/context/socket-context/socket-context.tsx';

export const SocketProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [isConnected, setIsConnected] = useState(false);

  const [socket, setSocket] = useState<WebSocket | null>(null);

  useEffect(() => {
    // TODO: Pass public domain web.talksy.ru
    const socketInstance = new (ClientIO as any)('http://localhost:5173', {
      path: `${API_BASE}/api/socket/io`,
      addTrailingSlash: false,
    });

    socketInstance.on('connect', () => {
      setIsConnected(true);
    });

    socketInstance.on('disconnect', () => {
      setIsConnected(false);
    });

    setSocket(socketInstance);

    return () => {
      socketInstance.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
